export default {
  'Cases types': 'TIPOS DE MALETINES',
  'Possible contents of the case': 'Posibles contenidos del maletín',
  'Other cases': 'OTROS CASOS',
  'Open for': 'Abierto para',
};
